module.exports = __webpack_public_path__ + "img/explosion-1.06aabafd.png";